/**
 * Route data loader for the Space Owner Landing Page.
 *
 * The page renders hardcoded, translated content and fetches nothing, so there
 * is no reducer registered for it in `containers/reducers.js` — only this
 * no-op `loadData`, which the route configuration requires.
 */

// ================ loadData ================ //

export const loadData = () => () => {
  return Promise.resolve();
};
